import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectEmployeesListItems } from "../../../../../../redux/employees/selector";
import { employees } from "../../../../../../redux/employees/action";
import { selectListItems } from "../../../../../../redux/library/selector";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const ManagementEmployees = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectEmployeesListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'FirstName', headerName: 'First Name',searchField: 'FirstName', sortable: true, filter: true, filterType: 'text' },
      { field: 'LastName', headerName: 'Last Name' },
      {
        field: 'TypeId',
        headerName: 'Type',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.EmployementType }
      },
      { field: 'DepartmentId', headerName: 'Department' },
      { field: 'DesignationId', headerName: 'Designation' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },

    ]);
  }

  const fetchEmployees = () => {

    dispatch(employees.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/employees/list`,
      entity: 'employees',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc"
      }
    }))
  }
  useEffect(() => {

    createColumnDefs()
    fetchEmployees()
  }, [pageData,pageSize])

  
  

  

  
  const handleReloadData = () => {
    fetchEmployees()
  }
  const additionButtons: any = [
   
    
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "FirstName",
        FieldText: "FirstName",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } 

    dispatch(employees.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/employees/list`,
      entity: 'employees',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }

  //   const additionButtons: any = [
  //     {
  //       name: 'Add employees',
  //       callback: () => handleAdd(),
  //     }
  //   ];

 

  return (
    <>
      {itemsData?.isLoading ?
        <PageLoader /> :
        <Table 
        checkboxConfig={{
          allowMultiSelect: true,
          defaultSelectedIds: [],
          isDisabled: false,
          keyColumn: 'Id',
      }}
        columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
        additionButtons={additionButtons} enableFilter={true} onSearch={handleSearch} paginationData={itemsData?.result?.pagination} headingName="Employees" />
      }
    </>
  );
};

export default ManagementEmployees;